export default "__VITE_ASSET__mqMMD7WC__"